<!-- eslint-disable max-len -->
<template>
  <v-card-text>
    <v-row>
      <!-- Cobra -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title id="breakWord" class="font-weight-medium">Are there any employees currently on COBRA or eligible?</v-list-item-title>
          <v-list-item-subtitle id="breakWord">{{ benefitsPacket.flags.employeesOnCobra }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-col cols="12">
        <v-data-table
          dense
          :headers="headers"
          :items="benefitsPacket.cobraCurrentPeriod"
          item-key="name"
          hide-default-footer
        >
          <template v-slot:top>
            <div class="font-weight-medium">Cobra Employees</div>
          </template>
        </v-data-table>
      </v-col>

      <!-- Election -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title id="breakWord" class="font-weight-medium">Are there any employees still within their COBRA election period or may become eligible as of the proposed medical coverage effective date?</v-list-item-title>
          <v-list-item-subtitle id="breakWord">{{ benefitsPacket.flags.employeesinCobraElectionPeriod }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-col cols="12">
        <v-data-table
          dense
          :headers="headers"
          :items="benefitsPacket.cobraElectionPeriod"
          item-key="name"
          hide-default-footer
        >
          <template v-slot:top>
            <div class="font-weight-medium">Election Employees</div>
          </template>
        </v-data-table>
      </v-col>

      <!-- Pregnant -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title id="breakWord" class="font-weight-medium">Is anyone currently pregnant? This includes employees, dependents, or COBRA participants.</v-list-item-title>
          <v-list-item-subtitle id="breakWord">{{ benefitsPacket.flags.currentPregnancies }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-col cols="12">
        <v-data-table
          dense
          :headers="pregnancyHeaders"
          :items="benefitsPacket.pregnancies"
          item-key="dueDate"
          hide-default-footer
        >
          <template v-slot:top>
            <div class="font-weight-medium">Pregnant Employees</div>
          </template>
        </v-data-table>
      </v-col>

    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'CobraEmployees',
  data: () => ({
    temp: null,
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Birth Date', value: 'dob' },
      { text: 'Effective Date', value: 'effectiveDate' },
      { text: 'Event Date', value: 'dateOfEvent' },
      { text: 'Activating Event', value: 'event' },
    ],
    pregnancyHeaders: [
      {
        text: 'Due Date',
        align: 'start',
        sortable: false,
        value: 'dueDate',
      },
      { text: 'Condition', value: 'condition' },
    ],
  }),
  computed: {
    benefitsPacket() {
      return this.$store.state.benefitsPacket;
    },
  },
};
</script>

<style lang="scss" scoped>
#breakWord {
  overflow: unset;
  text-overflow: unset;
  white-space: unset;
  word-break: break-word;
}
</style>
